import { index, sqliteTable, text } from 'drizzle-orm/sqlite-core'

/**
 * Nonces of signed hook requests (`/api/hooks/*`: build reports and rebuild requests), kept until their clock window
 * has passed, so a captured request cannot be replayed.
 */
export const hookNonces = sqliteTable(
  'hook_nonces',
  {
    nonce: text('nonce').primaryKey(),
    expiresAt: text('expires_at').notNull(),
  },
  (t) => [index('ix_hook_nonces_expires_at').on(t.expiresAt)],
)
